import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useToast } from './hooks/useToast';
import { onSessionExpired } from './session';

/**
 * Bridges the Apollo error link to the router.
 *
 * The link detects an expired session and clears the token, but it lives
 * outside React and cannot navigate — so it announces the expiry and this
 * listener, mounted inside the router, does the redirect.
 */
export const SessionExpiryHandler = () => {
    const navigate = useNavigate();
    const { error: toastError } = useToast();

    useEffect(() => {
        return onSessionExpired(() => {
            toastError('Session closed, please login again.');
            // Replace, not push: the page the session died on is no longer
            // reachable, so Back should not lead to it only to bounce again.
            navigate('/account/login', { replace: true });
        });
    // useToast returns a fresh object each render, so it is left out of the
    // deps to avoid resubscribing on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    return null;
};
